
function Datetime(now) {
    this.date = typeof now !== 'undefined' ? new Date(now):new Date();
}
/**
 *
 * @param f 支持 y+|M+|d+|H+|m+|s+|S 占位符
 * @param s 要解析的字符串
 * @param _f 支持 y+|M+|d+|H+|m+|s+|S 占位符
 * @returns {string}
 */
Datetime.prototype.format = function(f,s,_f){
    var date = this.date;
    if (s) this.parse(s, _f);
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    var fmt = f ? f : 'yyyy-MM-dd HH:mm:ss';
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
};
/**
 *
 * @param s 要解析的字符串
 * @param f 支持 y+|M+|d+|H+|m+|s+|S 占位符
 * @returns {Date}
 */
Datetime.prototype.parse = function(s,f){
    if(!s) return null;
    var date = this.date;
    var ymd=[date.getFullYear(),date.getMonth(),date.getDate(),
        date.getHours(),date.getMinutes(),date.getSeconds(),date.getMilliseconds()];
    var o = {
        "y+": function(n){  ymd[0]=n; },
        "M+": function(n){  ymd[1]=n-1; },
        "d+": function(n){  ymd[2]=n; },
        "H+": function(n){  ymd[3]=n},
        "m+": function(n){  ymd[4]=n},
        "s+": function(n){  ymd[5]=n },
        "S" : function(n){  ymd[6]=n }
    };
    var p = function(f){
        var s = "";
        var fs = f.match(/(y+|M+|d+|H+|m+|s+|S)/g);
        for(var i=0; i<fs.length; i++){
            s += fs[i].substr(0,1);
        }
        return s;
    };
    var fmt = f ? p(f) : 'yMdHmsS';
    var vals = s.split(/[^0-9]/g);

    for (var k in o){
        var i = fmt.search(new RegExp("(" + k + ")"));
        if (i >= 0 && vals[i]){
            o[k](+vals[i]);
        }
    }
    //特殊处理年月日，因为有些年月可能没有某些日
    date.setFullYear.apply(date,ymd.slice(0,3));
    //再设置时分秒毫秒
    date.setHours.apply(date,ymd.slice(3));
    return date;
};
/**
 *
 * @param now
 * @returns {Datetime}
 */
module.exports = function (now) {
    return new Datetime(now);
};


//////////////////
// WEBPACK FOOTER
// ./src/core/datetime.js
// module id = 196
// module chunks = 0